import { render, staticRenderFns } from "./courseDetailsSpecial.vue?vue&type=template&id=e51fe96e&"
import script from "./courseDetailsSpecial.vue?vue&type=script&lang=js&"
export * from "./courseDetailsSpecial.vue?vue&type=script&lang=js&"
import style0 from "./courseDetailsSpecial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports